import React, { useEffect } from 'react';
import { getPaginationFilter ,getTableSearchFilter} from '../../util/pagination';
import { DataTableHeader } from '../dataTableHeader';
import { Field } from '../dataTableHeader/DataTableHeader';

interface AdvancedTableFiltersLegacyProps {
    fields: Field[];
    pageName: string;
    onLoad: (sort: any, filter: any, pagination: any) => void;
    refresh: Promise<void> | null;
    hasCustomFilter: boolean;
    pending: boolean;
    intl: any;
    filter: any[];
    timeFilterField: string | undefined;
    timeFilter: any;
    customFilter: any[];
    sort: any;
    pagination: any;
    criteria: any;
    showSearchFilters: boolean;
    criteriasSaveEnabled: boolean;
    waitForCriteriaFilter: boolean;
    filterData: any; 
    userSessionId?:any;
    actions: {
        setFilter: (filter: any[]) => void;
        setPage: (page: any) => void;
        setCustomFilter: (filter: any[]) => void;
        saveCriteriaFilter: (criteria: any, callback: () => void) => void;
        updateCriteriaFilter: (criteria: any, callback: () => void) => void;
        setSelectedFilter: (filter: any | null) => void;
        searchGetByName: (name: { name: string },callback?: () => void) => void;
        setListData: (data: any[]) => void;
    };
}

export default function AdvancedTableFiltersOld({
    fields, pageName, onLoad, refresh, hasCustomFilter,
    pending, intl,
    filter, timeFilterField, timeFilter, customFilter, sort, pagination,
    criteria, showSearchFilters,
    criteriasSaveEnabled, waitForCriteriaFilter, filterData,userSessionId,
    actions: { setFilter, setPage, setCustomFilter, saveCriteriaFilter, updateCriteriaFilter,
        setSelectedFilter, searchGetByName, setListData }
}: AdvancedTableFiltersLegacyProps) {
    const isSummary= window.location.href.includes("fromSummary")
    useEffect(() => {
        if (showSearchFilters) {
            if (waitForCriteriaFilter) {
                return
            }
        }
        if (!refresh) {
            handleRefresh();
            return;
        }
        refresh.then(handleRefresh as any);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh, waitForCriteriaFilter]);

    useEffect(() => {
        sessionStorage.removeItem("duplicated");
    }, [pageName]);

    useEffect(() => {
        let filters = sessionStorage.getItem("pages") as any;
            filters = JSON.parse(filters)
        var navigationType = ((filters  && filters['claimAnalysis-landing']?.navigationType) || window.performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming)
            .type;
            ;
        if (
            (navigationType === "back_forward" || 
                navigationType === "reload") &&
            !sessionStorage.getItem("duplicated") && !isSummary //Do not cache if coming from summary Both summary & claim analysis work adjacently
        ) {
            //Handling the persist of filters in both reload and duplication case
            if (filters) {
                setPage({...filters[pageName],navigationType:undefined});      
            }
            sessionStorage.setItem("duplicated", "true");
        }
        if (filterData) {
            const { list, ...rest } = filterData;
            try {
                sessionStorage.setItem("pages", JSON.stringify({ ...filters, [pageName]: rest }));
            } catch (e) {
                console.error( e);
            }
        }
        
    }, [filterData]);


    function handleLoad( { newSort, newFilter, newTimeFilter, newPagination } : {
        newSort?: any, newFilter?: any, newTimeFilter?: any, newPagination?: any
    } = {}) {
        const paginationFilters = getPaginationFilter( newFilter || filter, timeFilterField, newTimeFilter || timeFilter, customFilter.filter(item => item.value !== 'both'));
         if (!hasCustomFilter) {
            setCustomFilter(customFilter);
        }
        const quickSearch = getTableSearchFilter(filterData?.searchTerm)
    
        onLoad(
            newSort || sort,
            filterData?.searchTerm?.length > 0
                ? filterData?.ignoreAcknowledgement
                    ? quickSearch
                    : {
                          ...( paginationFilters ?? [] ),
                          operands: [
                              ...( paginationFilters?.operands ?? []),
                              ...quickSearch?.operands,
                          ],
                      }
                : paginationFilters,
            newPagination || pagination
        );
    }



    function handleRefresh(hardRefresh?: boolean) {
       setListData([]);
       if (!pending || hardRefresh || sessionStorage.getItem('duplicated')) {
            handleLoad({
                newPagination: pagination,
                newSort: sort,
            });
        }
    }


    const [stagedFilters, setStagedFilters] = React.useState<any[]>(filter);

    useEffect(() => {
        setStagedFilters(filter);
    }, [filter]);

    function handleFilter(newFilter, isAddFilter) {
        if (!pending) {
            const hasNewFilter = newFilter?.equator && newFilter?.field && newFilter?.value !== undefined;
            let nextFilters = stagedFilters;

            if (hasNewFilter) {
                nextFilters = [newFilter, ...stagedFilters];
            }

            if (isAddFilter) {
                // Stage only (no API call)
                setStagedFilters(nextFilters);
            } else {
                // Commit all changes (triggers API and updates global state)
                setListData([]);
                setFilter(nextFilters);
                handleLoad({
                    newFilter: nextFilters,
                    newPagination: {
                        ...pagination,
                        currentPage: 1,
                    }
                });
            }
        }
    }

    function handleDeleteFilter(deletedFilter, index) {
        const nextFilters = stagedFilters.filter((_, i) => i !== index);
        setStagedFilters(nextFilters);
        setFilter(nextFilters);
        setListData([]);
        handleLoad({
            newFilter: nextFilters,
            newPagination: {
                ...pagination,
                currentPage: 1,
            }
        });
    }

    function handleUpdateFilter(newFilterObj, index, isAddFilter) {
        if (index === null) return;

        const nextFilters = stagedFilters.map((f, i) => (i === index ? newFilterObj : f));
        
        if (isAddFilter) {
            // + button clicked: update the UI only
            setStagedFilters(nextFilters);
        } else {
            // Update button clicked: commit everything
            setListData([]);
            setFilter(nextFilters);
            handleLoad({
                newFilter: nextFilters,
            });
        }
    }

    function handleFilterClear() {
        // if (filter && filter.length > 0) { //Even if crieria has no filters we should still be able to clear
            setListData([]);
            setFilter([]);
            setStagedFilters([]);
            setSelectedFilter(null);
            handleLoad({
                newFilter: [],
                newPagination: {
                    ...pagination,
                    currentPage: 1,
                }
            });
            
        if (pageName === "claimAnalysis-landing") {
            localStorage.setItem("isCriteriaCleared", "true")

        }
        // }
    }


    function refreshPageCriterias() {
        const pName = {
            name: pageName,
        }
        searchGetByName(pName,handleRefresh);
    }

    function SaveFilterCallback(handleClose) {
        handleClose();
        refreshPageCriterias();

    }

    function handleFilterSave(filterCriteria, handleClose, existingCriteria) {
        let searchCriteria = {
            ...filterCriteria,
            name: pageName,
        }
        if (existingCriteria && existingCriteria.id) {
            updateCriteriaFilter(searchCriteria, () => {
                SaveFilterCallback(handleClose)
            });
        } else {
            
            saveCriteriaFilter(searchCriteria, () => {
                SaveFilterCallback(handleClose)
            });
        }
    }

    return (
            <DataTableHeader
                fields={fields}
                intl={intl}
                filter={stagedFilters}
                customFilter={customFilter}
                onFilterChange={handleFilter}
                onFilterDelete={handleDeleteFilter}
                onFilterClear={handleFilterClear}
                onFilterSave={handleFilterSave}
                onFilterUpdate={handleUpdateFilter}
                criteria={criteria}
                saveEnabled={criteriasSaveEnabled}
                pending={pending}
                pageName={pageName}
                userSessionId={userSessionId}
            />
    );
};                   